/**
 * Handles Ajax requests on JSON endpoints
 */

export class Endpoint {
  constructor(url) {
    this.url = url
  }

  getData = async (query = "", path = "") => {
    const url = `${this.url}${path}${query && "?"}${query}`
    const data = await fetch(url)
    return data.json()
  }
}
